<template>
  <div>
    <aha-chat-box
      @sendMessage="handleSendMessageFromAudience"
      @retrySendingMessage="retry"
      :totalLiveParticipants="totalLiveParticipants"
      :chatMessages="chatMessages"
      :isSendingMessage="isSendingMessage"
      :filteringProfanity="!!presentation.filteringProfanity"
      :isDarkTheme="isDarkTheme"
      chatsHeight="200px"
      :canClose="false"
      :emptyContentHTML="emptyContentHTML"
      :userId="audienceId"
      class="chat-box__custom"
    />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Socket from '@/socket'
import colorUtils from 'storybook-utils/colors'

export default {
  props: {
    teamName: {
      type: String,
      required: false,
      default: '',
    },
    isDarkTheme: {
      type: Boolean,
      required: false,
    },
  },

  data: () => ({
    totalLiveParticipants: 100,
  }),

  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      slideActive: (state) => state.slide,
      audienceId: (state) => state.audienceId,
      audienceName: (state) => state.audienceName,
    }),
    ...mapGetters('presentationChat', ['chatMessages', 'isSendingMessage']),

    emptyContentHTML() {
      return `
        <p class="chat-box__empty-heading">${this.$t('startTheConversation')}</p>
        <p class="chat-box__empty-text">${this.$t('noChatMessagesYet')}</br>${this.$t('typeSomethingToSayHi')}</p>
      `
    },
  },

  mounted() {
    // get messages from audience
    this.subscribeChatRoomAction({
      presentation: this.presentation,
      audienceId: this.audienceId,
      audienceName: this.audienceName,
    })
  },

  destroyed() {
    this.unsubscribeChatRoomAction({
      presentation: this.presentation,
    })
  },

  methods: {
    ...mapActions('presentationChat', [
      'subscribeChatRoomAction',
      'unsubscribeChatRoomAction',
      'sendMessageAction',
    ]),

    retry(message) {
      this.handleSendMessageFromAudience(message)
    },

    handleSendMessageFromAudience(message) {
      const {
        audienceName: name,
        audienceEmoji: avatar,
      } = this.$store.state

      const payload = {
        uniqueAccessCode: this.presentation.uniqueAccessCode,
        presentationId: this.presentation.id,
        name,
        userId: this.audienceId,
        avatar,
        message,
        type: 'text',
        role: 'audience',
        socketId: Socket.getSocketId(),
        timestamp: Date.now(),
        color: colorUtils.getAudienceColor(this.audienceId),
        teamName: this.teamName,
      }

      this.sendMessageAction({ payload })
    },
  },
}
</script>

<style lang="scss" scoped>
.chat-box__custom {
  &/deep/ .chat-message .__user-type-icon {
    margin-bottom: -3px;
  }
}
</style>
